import { TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { PublicKey } from "@solana/web3.js";
import { TokenInfo } from "./type";
import { NetworkName } from "@/config";
import { getNetworkConfig } from "@/config";

export function getSolInfo(network: NetworkName): TokenInfo {
  const config = getNetworkConfig(network);
  return {
    chainId: 101,
    address: PublicKey.default.toBase58(),
    programId: TOKEN_PROGRAM_ID.toBase58(),
    decimals: 9,
    symbol: config.NATIVE_TOKEN_SYMBOL,
    name: config.FULL_TOKEN_NAME,
    logoURI: config.GITHUB_LOGO_URL,
    tags: [],
    priority: 2,
    type: "cobaltx",
    extensions: {
      coingeckoId: "solana",
    },
  };
}

export function getTokenWSol(network: NetworkName): TokenInfo {
  const config = getNetworkConfig(network);
  return {
    chainId: 101,
    address: config.WSOL_MINT_ADDRESS,
    programId: TOKEN_PROGRAM_ID.toBase58(),
    decimals: 9,
    symbol: config.WRAPPED_TOKEN_SYMBOL || "",
    name: config.FULL_TOKEN_NAME,
    logoURI: config.GITHUB_LOGO_URL,
    tags: [],
    priority: 2,
    type: "cobaltx",
    extensions: {
      coingeckoId: "solana",
    },
};
}
